import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export const Container = styled.div`
  border: 1px solid red;
  display: flex;
  gap: 24px;
`

export const Trash = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  width: 24px;
  height: 24px;
  margin-top: 12px;

  background-color: transparent;

  border: none;

  img {
    width: 24px;
    height: 24px;
  }
`

export const Plus = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  width: 24px;
  height: 24px;
  margin-top: 12px;

  background-color: transparent;

  border: 1px solid black;
  border-radius: 50%;

  img {
    width: 12px;
    height: 12px;
  }
`
